import React, { lazy, Suspense } from 'react';

const LazyExpanse = lazy(() => import('./Expanse'));

const Expanse = (props: JSX.IntrinsicAttributes & { children?: React.ReactNode; }) => (
  <Suspense fallback={null}>
    <LazyExpanse {...props} />
  </Suspense>
);

export default Expanse;
